import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { errorMsg } from "../../../Apis/functions";
import { GetBuildingApartmentById } from "../../../reduxToolkit/Building/BuildingApi";
import { UNIT_DETAIL_MODEL } from "../Model/Model";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 * Details logic of one unit of the building: the residents of the apartment are
 * loaded every time the modal is opened and split into the main resident and the
 * household members the card grid renders.
 *
 * @param {Object} props
 * @param {boolean} props.show - Modal visibility, the fetch runs when it opens.
 * @param {string} props.apartmentId - Unit the residents are loaded for.
 * @returns {Object} Localization function, the unit detail and its loading flag.
 */
export const UnitDetailsModalApp = ({ show, apartmentId }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [unitDetail, setUnitDetail] = useState(UNIT_DETAIL_MODEL);
    const [loading, setLoading] = useState(false);

    // The residents are read again on every open, they change from the tabs of
    // the detail while the modal stays mounted
    useEffect(() => {
        if (!show || !apartmentId) {
            setUnitDetail(UNIT_DETAIL_MODEL);
            return;
        }

        getUnitDetail();
    }, [show, apartmentId]);

    /**
     * Loads the residents of the apartment the modal is showing.
     */
    const getUnitDetail = () => {
        setLoading(true);

        dispatch(GetBuildingApartmentById(apartmentId)).then((response) => {
            const { success, data, code } = response?.payload?.data || {};
            setLoading(false);

            if (!success) {
                errorMsg(code);
                return;
            }

            setUnitDetail(UNIT_DETAIL_MODEL.set(data));
        });
    };

    return {
        t,
        unitDetail,
        loading
    };
};
